var map = {
	"./01.svg": "./src/assets/avatarPack/01.svg",
	"./02.svg": "./src/assets/avatarPack/02.svg",
	"./03.svg": "./src/assets/avatarPack/03.svg",
	"./04.svg": "./src/assets/avatarPack/04.svg",
	"./05.svg": "./src/assets/avatarPack/05.svg",
	"./06.svg": "./src/assets/avatarPack/06.svg",
	"./07.svg": "./src/assets/avatarPack/07.svg",
	"./08.svg": "./src/assets/avatarPack/08.svg",
	"./09.svg": "./src/assets/avatarPack/09.svg",
	"./10.svg": "./src/assets/avatarPack/10.svg",
	"./100.svg": "./src/assets/avatarPack/100.svg",
	"./101.svg": "./src/assets/avatarPack/101.svg",
	"./102.svg": "./src/assets/avatarPack/102.svg",
	"./103.svg": "./src/assets/avatarPack/103.svg",
	"./104.svg": "./src/assets/avatarPack/104.svg",
	"./105.svg": "./src/assets/avatarPack/105.svg",
	"./106.svg": "./src/assets/avatarPack/106.svg",
	"./107.svg": "./src/assets/avatarPack/107.svg",
	"./108.svg": "./src/assets/avatarPack/108.svg",
	"./109.svg": "./src/assets/avatarPack/109.svg",
	"./11.svg": "./src/assets/avatarPack/11.svg",
	"./110.svg": "./src/assets/avatarPack/110.svg",
	"./12.svg": "./src/assets/avatarPack/12.svg",
	"./13.svg": "./src/assets/avatarPack/13.svg",
	"./14.svg": "./src/assets/avatarPack/14.svg",
	"./15.svg": "./src/assets/avatarPack/15.svg",
	"./16.svg": "./src/assets/avatarPack/16.svg",
	"./17.svg": "./src/assets/avatarPack/17.svg",
	"./18.svg": "./src/assets/avatarPack/18.svg",
	"./19.svg": "./src/assets/avatarPack/19.svg",
	"./20.svg": "./src/assets/avatarPack/20.svg",
	"./21.svg": "./src/assets/avatarPack/21.svg",
	"./22.svg": "./src/assets/avatarPack/22.svg",
	"./23.svg": "./src/assets/avatarPack/23.svg",
	"./24.svg": "./src/assets/avatarPack/24.svg",
	"./25.svg": "./src/assets/avatarPack/25.svg",
	"./26.svg": "./src/assets/avatarPack/26.svg",
	"./27.svg": "./src/assets/avatarPack/27.svg",
	"./28.svg": "./src/assets/avatarPack/28.svg",
	"./29.svg": "./src/assets/avatarPack/29.svg",
	"./30.svg": "./src/assets/avatarPack/30.svg",
	"./31.svg": "./src/assets/avatarPack/31.svg",
	"./32.svg": "./src/assets/avatarPack/32.svg",
	"./33.svg": "./src/assets/avatarPack/33.svg",
	"./34.svg": "./src/assets/avatarPack/34.svg",
	"./35.svg": "./src/assets/avatarPack/35.svg",
	"./36.svg": "./src/assets/avatarPack/36.svg",
	"./37.svg": "./src/assets/avatarPack/37.svg",
	"./38.svg": "./src/assets/avatarPack/38.svg",
	"./39.svg": "./src/assets/avatarPack/39.svg",
	"./40.svg": "./src/assets/avatarPack/40.svg",
	"./41.svg": "./src/assets/avatarPack/41.svg",
	"./42.svg": "./src/assets/avatarPack/42.svg",
	"./43.svg": "./src/assets/avatarPack/43.svg",
	"./44.svg": "./src/assets/avatarPack/44.svg",
	"./45.svg": "./src/assets/avatarPack/45.svg",
	"./46.svg": "./src/assets/avatarPack/46.svg",
	"./47.svg": "./src/assets/avatarPack/47.svg",
	"./48.svg": "./src/assets/avatarPack/48.svg",
	"./49.svg": "./src/assets/avatarPack/49.svg",
	"./50.svg": "./src/assets/avatarPack/50.svg",
	"./51.svg": "./src/assets/avatarPack/51.svg",
	"./52.svg": "./src/assets/avatarPack/52.svg",
	"./53.svg": "./src/assets/avatarPack/53.svg",
	"./54.svg": "./src/assets/avatarPack/54.svg",
	"./55.svg": "./src/assets/avatarPack/55.svg",
	"./56.svg": "./src/assets/avatarPack/56.svg",
	"./57.svg": "./src/assets/avatarPack/57.svg",
	"./58.svg": "./src/assets/avatarPack/58.svg",
	"./59.svg": "./src/assets/avatarPack/59.svg",
	"./60.svg": "./src/assets/avatarPack/60.svg",
	"./61.svg": "./src/assets/avatarPack/61.svg",
	"./62.svg": "./src/assets/avatarPack/62.svg",
	"./63.svg": "./src/assets/avatarPack/63.svg",
	"./64.svg": "./src/assets/avatarPack/64.svg",
	"./65.svg": "./src/assets/avatarPack/65.svg",
	"./66.svg": "./src/assets/avatarPack/66.svg",
	"./67.svg": "./src/assets/avatarPack/67.svg",
	"./68.svg": "./src/assets/avatarPack/68.svg",
	"./69.svg": "./src/assets/avatarPack/69.svg",
	"./70.svg": "./src/assets/avatarPack/70.svg",
	"./71.svg": "./src/assets/avatarPack/71.svg",
	"./72.svg": "./src/assets/avatarPack/72.svg",
	"./73.svg": "./src/assets/avatarPack/73.svg",
	"./74.svg": "./src/assets/avatarPack/74.svg",
	"./75.svg": "./src/assets/avatarPack/75.svg",
	"./76.svg": "./src/assets/avatarPack/76.svg",
	"./77.svg": "./src/assets/avatarPack/77.svg",
	"./78.svg": "./src/assets/avatarPack/78.svg",
	"./79.svg": "./src/assets/avatarPack/79.svg",
	"./80.svg": "./src/assets/avatarPack/80.svg",
	"./81.svg": "./src/assets/avatarPack/81.svg",
	"./82.svg": "./src/assets/avatarPack/82.svg",
	"./83.svg": "./src/assets/avatarPack/83.svg",
	"./84.svg": "./src/assets/avatarPack/84.svg",
	"./85.svg": "./src/assets/avatarPack/85.svg",
	"./86.svg": "./src/assets/avatarPack/86.svg",
	"./87.svg": "./src/assets/avatarPack/87.svg",
	"./88.svg": "./src/assets/avatarPack/88.svg",
	"./89.svg": "./src/assets/avatarPack/89.svg",
	"./90.svg": "./src/assets/avatarPack/90.svg",
	"./91.svg": "./src/assets/avatarPack/91.svg",
	"./92.svg": "./src/assets/avatarPack/92.svg",
	"./93.svg": "./src/assets/avatarPack/93.svg",
	"./94.svg": "./src/assets/avatarPack/94.svg",
	"./95.svg": "./src/assets/avatarPack/95.svg",
	"./96.svg": "./src/assets/avatarPack/96.svg",
	"./97.svg": "./src/assets/avatarPack/97.svg",
	"./98.svg": "./src/assets/avatarPack/98.svg",
	"./99.svg": "./src/assets/avatarPack/99.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/avatarPack sync recursive .*\\.svg";